import { render, staticRenderFns } from "./ArticleComment.vue?vue&type=template&id=d6989df8&scoped=true"
import script from "./ArticleComment.vue?vue&type=script&lang=js"
export * from "./ArticleComment.vue?vue&type=script&lang=js"
import style0 from "./ArticleComment.vue?vue&type=style&index=0&id=d6989df8&prod&lang=less&scoped=true"
import style1 from "./ArticleComment.vue?vue&type=style&index=1&id=d6989df8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6989df8",
  null
  
)

export default component.exports